$mol_check_expand $mol_check
	Icon $mol_icon_chevron
	level 0
	style *
		^
		paddingLeft <= level_style \0px
	checked? <=> expanded? false
	enabled <= expandable false
